import { IconComponent } from './types';

const ChartIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="inside-path-1" fill="white">
      <path d="M10.8769 6.46154C10.9874 6.46154 11.0773 6.55112 11.0733 6.6615C11.0363 7.68687 10.715 8.68326 10.1435 9.53855C9.53495 10.4493 8.66996 11.1592 7.65794 11.5784C6.64592 11.9976 5.53232 12.1073 4.45796 11.8936C3.38361 11.6799 2.39675 11.1524 1.62218 10.3778C0.84761 9.60326 0.320123 8.6164 0.10642 7.54204C-0.107283 6.46769 0.00239725 5.35409 0.42159 4.34206C0.840783 3.33004 1.55066 2.46505 2.46146 1.85648C3.31675 1.28499 4.31314 0.963725 5.3385 0.92669C5.44888 0.922703 5.53846 1.01262 5.53846 1.12308V6.26154C5.53846 6.372 5.628 6.46154 5.73846 6.46154H10.8769Z" />
    </mask>
    <path
      d="M10.8769 6.46154C10.9874 6.46154 11.0773 6.55112 11.0733 6.6615C11.0363 7.68687 10.715 8.68326 10.1435 9.53855C9.53495 10.4493 8.66996 11.1592 7.65794 11.5784C6.64592 11.9976 5.53232 12.1073 4.45796 11.8936C3.38361 11.6799 2.39675 11.1524 1.62218 10.3778C0.84761 9.60326 0.320123 8.6164 0.10642 7.54204C-0.107283 6.46769 0.00239725 5.35409 0.42159 4.34206C0.840783 3.33004 1.55066 2.46505 2.46146 1.85648C3.31675 1.28499 4.31314 0.963725 5.3385 0.92669C5.44888 0.922703 5.53846 1.01262 5.53846 1.12308V6.26154C5.53846 6.372 5.628 6.46154 5.73846 6.46154H10.8769Z"
      stroke="currentColor"
      strokeWidth="2"
      mask="url(#inside-path-1)"
    />
    <mask id="inside-path-2" fill="white">
      <path d="M11.8 5.53846C11.9105 5.53846 12.0004 5.44889 11.9964 5.3385C11.9726 4.67941 11.8312 4.0293 11.5784 3.41898C11.3001 2.74703 10.8921 2.13647 10.3778 1.62218C9.86355 1.10788 9.25299 0.699924 8.58103 0.42159C7.97072 0.16879 7.32061 0.0274211 6.66152 0.00361061C6.55113 -0.000377152 6.46156 0.089543 6.46156 0.2V5.33846C6.46156 5.44892 6.5511 5.53846 6.66156 5.53846H11.8Z" />
    </mask>
    <path
      d="M11.8 5.53846C11.9105 5.53846 12.0004 5.44889 11.9964 5.3385C11.9726 4.67941 11.8312 4.0293 11.5784 3.41898C11.3001 2.74703 10.8921 2.13647 10.3778 1.62218C9.86355 1.10788 9.25299 0.699924 8.58103 0.42159C7.97072 0.16879 7.32061 0.0274211 6.66152 0.00361061C6.55113 -0.000377152 6.46156 0.089543 6.46156 0.2V5.33846C6.46156 5.44892 6.5511 5.53846 6.66156 5.53846H11.8Z"
      stroke="currentColor"
      strokeWidth="2"
      mask="url(#inside-path-2)"
    />
  </svg>
);

export default ChartIcon;
